import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MenuConfiguration } from 'src/business/models/main-configuration.model';
import { Guard } from 'src/core-lib/misselaineous/guards';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';

@Component({
    selector: 'app-footer-bedrock',
    templateUrl: './footer-bedrock.component.html',
    styleUrls: ['./footer-bedrock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:[CommonModule, TranslateModule, MediaModule],

    standalone: true,
})
export class FooterBedrockComponent {
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');
    @HostBinding('style.--bedrock-text-color') bedrockTextColor: string = StorageUtil.get<MenuConfiguration>('menu').bedrockTextColor;
    @HostBinding('style.--bedrock-background-color') bedrockBackgroundColor: string = StorageUtil.get<MenuConfiguration>('menu').bedrockBackgroundColor;
    get preRock(): string {
        return [this.menu?.store?.pageTitle, this.menu?.store?.phone, this.menu?.store?.email].filter(_ => _ != null && _ != '').join(' - ')
    }
}
